/* ============
 * Auth Mutations
 * ============
 *
 * The mutations available for the auth module.
 */

import Vue from 'vue';
import { HTTP_DESKDAF, HTTP_EDOCSIGN } from '../../../plugins/axios';
import {
  CHECK,
  LOGIN,
  LOGOUT,
  CHECK_DESKDAF,
  LOGIN_DESKDAF,
  LOGOUT_DESKDAF,
  CHECK_EDOCSIGN,
  LOGIN_EDOCSIGN,
  LOGOUT_EDOCSIGN,
  DOMAINS,
  LOGIN_ADMIN_DRH_CREDENTIALS, RESET_DRH_SESSION,

} from './mutation-types';

export default {
  /**
   * Mutation to check if the user is authenticated.
   *
   * @param {Object} state The current state of the store.
   */
  [CHECK](state) {
    const session = JSON.parse(localStorage.getItem('session'));
    if (session) {
      state.authenticated = !!session.token;
    } else {
      state.authenticated = false;
    }
    if (state.authenticated) {
      state.session.token = session.token;
      state.session.login = session.login;
      Vue.$http.defaults.headers.common.Authorization = `Bearer ${session.token}`;
    }
  },

  /**
   * Mutation to check if the user is authenticated to deskDaf.
   *
   * @param {Object} state The current state of the store.
   */

  [CHECK_DESKDAF](state) {
    const session = JSON.parse(localStorage.getItem('sessionDeskDaf'));
    if (session) {
      state.authenticatedDeskDaf = !!session.token;
      state.authenticated = !!session.token;
    } else {
      state.authenticatedDeskDaf = false;
    }
    if (state.authenticated && state.authenticatedDeskDaf) {
      state.tokenDeskDaf = session.token;
      HTTP_DESKDAF.defaults.headers.common.Authorization = `Bearer ${session.token}`;
    }
  },

  /**
   * Mutation to log the user in.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} session The session infos.
   */
  [LOGIN](state, session) {
    state.authenticated = true;
    localStorage.setItem('session', JSON.stringify(session));
    state.session.token = session.token;
    state.session.login = session.login;
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${session.token}`;
  },

  /**
   * Mutation to login the user to deskDaf.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} session The session infos.
   */


  // same as LOGIN for test (working)
  [LOGIN_DESKDAF](state, session) {
    state.authenticated = true;
    localStorage.setItem('sessionDeskDaf', JSON.stringify(session));
    state.tokenDeskDaf = session.token;
    state.session.login = session.login;
    HTTP_DESKDAF.defaults.headers.common.Authorization = `Bearer ${session.token}`;
  },

  /**
   * Mutation to check if the user is authenticated.
   *
   * @param {Object} state The current state of the store.
   */
  [CHECK_EDOCSIGN](state) {
    const token = JSON.parse(localStorage.getItem('sessionEdocSign'));
    if (token) {
      state.authenticatedEdocSign = !!token;
    } else {
      state.authenticatedEdocSign = false;
    }

    if (state.authenticatedEdocSign) {
      state.tokenEdocSign = token;
      localStorage.setItem('sessionEdocSign', JSON.stringify(token));
    }
  },

  /**
   * Mutation to log the user out.
   *
   * @param {Object} state The current state of the store.
   */
  [LOGOUT](state) {
    state.authenticated = false;
    state.authenticatedDeskRh = false;
    localStorage.removeItem('session');
    state.session.token = undefined;
    state.session.login = undefined;
    Vue.$http.defaults.headers.common.Authorization = '';
  },

  /**
   * Mutation to logout the user of deskDaf.
   *
   * @param {Object} state The current state of the store.
   */
  [LOGOUT_DESKDAF](state) {
    state.authenticated = false;
    state.authenticatedDeskDaf = false;
    state.tokenDeskDaf = undefined;
    state.session.login = undefined;
    localStorage.removeItem('sessionDeskDaf');
    localStorage.removeItem('perimeters');
  },

  /**
   * Mutation to log the user in.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} session The session infos.
   */
  [LOGIN_EDOCSIGN](state, sessionId) {
    state.authenticatedEdocSign = true;
    localStorage.setItem('sessionEdocSign', JSON.stringify(sessionId));
    state.tokenEdocSign = sessionId;
    HTTP_EDOCSIGN.defaults.headers.common.Authorization = sessionId;
  },

  /**
   * Mutation to log the user out.
   *
   * @param {Object} state The current state of the store.
   */
  [LOGOUT_EDOCSIGN](state) {
    state.authenticatedEdocSign = false;
    localStorage.removeItem('sessionEdocSign');
    localStorage.removeItem('perimeters');
  },

  [LOGIN_ADMIN_DRH_CREDENTIALS](state, credendials) {
    state.drhAdminCredentials = credendials;
  },

  [DOMAINS](state, domains) {
    state.authenticated = true;
    localStorage.removeItem('session');
    state.session.token = undefined;
    state.session.login = undefined;
    Vue.$http.defaults.headers.common.Authorization = '';
    const sortedDomains = domains.map((item) => {
      const newItem = { fullname: `${item.drhRef !== undefined ? item.drhRef : ''} - ${item.name !== undefined ? item.name : ''} (${item.siret !== undefined ? item.siret : ''}) - ${item.domain}` };
      return Object.assign(newItem, item);
    });

    state.domains = sortedDomains.sort((a, b) => {
      const nameA = a.fullname.toUpperCase(); // ignore upper and lowercase
      const nameB = b.fullname.toUpperCase(); // ignore upper and lowercase
      if (nameB.includes('EDOC-LEGACY-DOMAIN')) {
        console.log('legacy');
        return 1;
      }
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
  },

  [RESET_DRH_SESSION](state) {
    localStorage.removeItem('session');
    state.session.token = undefined;
    state.session.login = undefined;
    Vue.$http.defaults.headers.common.Authorization = '';
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js